import React from 'react';
import {NeuroMessage, useGuideConfig} from "@ignitesales/neuro-application";

const LandingPage = ({ componentClass, isLoadingNextPage, onStartGuideClick}) => {
  const { isRemoteSession } = useGuideConfig();

  const startGuide = () => {
    onStartGuideClick();
  };

  return (
    <div className={componentClass}>
      <div className={`${componentClass}__container`}>
        <div className={`${componentClass}__message`}>
          <NeuroMessage id="landing.title" tagName="h1" />
          <NeuroMessage id="landing.message" tagName="span" />
        </div>
        <button onClick={startGuide} disabled={isLoadingNextPage} className={`${componentClass}__btn btn`}>
          <NeuroMessage id="landing.getStartedBtn"/><span className="fa fa-angle-right"></span>
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
